import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export default function AccessDenied() {
  const navigate = useNavigate();
  const { user, isAuthenticated, loading } = useAuth();

  if (!loading && !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const getRedirectPathByUser = (user) => {
      if(['juez', 'Juez'].includes(user?.role)){
          return '/evaluations/all';
      }else {
          return '/';
      }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>🔒</div>

        <h1 style={styles.code}>403</h1>

        <h2 style={styles.title}>Acceso Restringido</h2>

        <p style={styles.description}>
          No tienes permisos para acceder a esta sección.
          <br />
          Si crees que esto es un error, contacta al administrador.
        </p>

        <button
          style={styles.button}
          onClick={() => navigate(getRedirectPathByUser(user))}
        >
          Volver al Dashboard
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#f8fafc',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  },
  card: {
    background: '#ffffff',
    padding: '48px 40px',
    borderRadius: '16px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
    textAlign: 'center',
    maxWidth: '420px',
    width: '100%',
    animation: 'fadeIn 0.3s ease-in-out',
  },
  icon: {
    fontSize: '36px',
    marginBottom: '16px',
  },
  code: {
    margin: 0,
    fontSize: '48px',
    fontWeight: '700',
    color: '#111827',
  },
  title: {
    margin: '8px 0 16px',
    fontSize: '20px',
    fontWeight: '600',
    color: '#374151',
  },
  description: {
    fontSize: '14px',
    color: '#6b7280',
    marginBottom: '28px',
    lineHeight: '1.6',
  },
  button: {
    background: '#111827',
    color: '#ffffff',
    border: 'none',
    padding: '12px 20px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.2s ease',
  },
};
